import React, { useState, useEffect } from 'react';
import { motion, useScroll } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';

const { FiMenu, FiX } = FiIcons;

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'The Book', path: '/chapters' },
  { label: 'About', path: '/about' },
  { label: 'Reviews', path: '/reviews' },
];

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { scrollY } = useScroll();
  const location = useLocation();

  useEffect(() => {
    return scrollY.onChange((latest) => setIsScrolled(latest > 50));
  }, [scrollY]);

  useEffect(() => setMenuOpen(false), [location]);

  return (
    <motion.nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        <Link to="/" className="font-serif font-bold text-xl tracking-wider text-brand-dark">
          ANDREI CIOMÎRTAN
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <Link
              key={l.path}
              to={l.path}
              className={`text-sm font-medium transition-colors duration-200 ${
                location.pathname === l.path ? 'text-brand-accent' : 'text-slate-600 hover:text-brand-dark'
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/chapters#buy"
            className="bg-brand-dark text-white px-6 py-2.5 rounded-full text-sm font-medium tracking-wide hover:bg-brand-accent transition-colors duration-300"
          >
            Get the Book
          </Link>
        </div>

        <button className="md:hidden text-brand-dark" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>
      </div>

      {menuOpen && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden bg-white border-t border-slate-100 shadow-lg px-6 py-6 flex flex-col gap-4"
        >
          {navLinks.map((l) => (
            <Link key={l.path} to={l.path} className="text-brand-dark font-medium py-1">
              {l.label}
            </Link>
          ))}
          <Link
            to="/chapters#buy"
            className="mt-2 bg-brand-dark text-white text-center px-6 py-3 rounded-full text-sm font-medium"
          >
            Get the Book
          </Link>
        </motion.div>
      )}
    </motion.nav>
  );
};

export default Navbar;